function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 25C0 12.8497 9.84974 3 22 3C34.1503 3 44 12.8497 44 25C44 37.1503 34.1503 47 22 47C9.84974 47 0 37.1503 0 25Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M22.3666 33.0667C24.5959 33.0667 26.3999 31.2627 26.3999 29.0334V20.6H25.2999V29.0334C25.2999 30.654 23.9873 31.9667 22.3666 31.9667C20.7459 31.9667 19.4333 30.654 19.4333 29.0334V19.8667C19.4333 19.3805 19.6264 18.9141 19.9702 18.5703C20.314 18.2265 20.7804 18.0333 21.2666 18.0333C21.7528 18.0333 22.2191 18.2265 22.5629 18.5703C22.9068 18.9141 23.0999 19.3805 23.0999 19.8667V27.5667C23.0999 27.97 22.7699 28.3 22.3666 28.3C21.9633 28.3 21.6333 27.97 21.6333 27.5667V20.6H20.5333V27.5667C20.5333 28.0529 20.7264 28.5192 21.0702 28.863C21.414 29.2069 21.8804 29.4 22.3666 29.4C22.8528 29.4 23.3191 29.2069 23.6629 28.863C24.0068 28.5192 24.1999 28.0529 24.1999 27.5667V19.8667C24.1999 18.246 22.8873 16.9333 21.2666 16.9333C19.6459 16.9333 18.3333 18.246 18.3333 19.8667V29.0334C18.3333 31.2627 20.1373 33.0667 22.3666 33.0667Z",
  fill: "#4D4D4D"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M26.6667 10.3333C26.6667 4.8104 31.1439 0.333252 36.6667 0.333252C42.1896 0.333252 46.6667 4.8104 46.6667 10.3333C46.6667 15.8561 42.1896 20.3333 36.6667 20.3333C31.1439 20.3333 26.6667 15.8561 26.6667 10.3333Z",
  fill: "#9AA5AD"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M40.6667 9.33325H39.6667V7.33325C39.6667 6.5376 39.3507 5.77454 38.7881 5.21193C38.2255 4.64932 37.4624 4.33325 36.6667 4.33325C35.8711 4.33325 35.108 4.64932 34.5454 5.21193C33.9828 5.77454 33.6667 6.5376 33.6667 7.33325V9.33325H32.6667C32.4015 9.33325 32.1472 9.43861 31.9596 9.62615C31.7721 9.81368 31.6667 10.068 31.6667 10.3333V14.3333C31.6667 14.5985 31.7721 14.8528 31.9596 15.0404C32.1472 15.2279 32.4015 15.3333 32.6667 15.3333H40.6667C40.932 15.3333 41.1863 15.2279 41.3739 15.0404C41.5614 14.8528 41.6667 14.5985 41.6667 14.3333V10.3333C41.6667 10.068 41.5614 9.81368 41.3739 9.62615C41.1863 9.43861 40.932 9.33325 40.6667 9.33325ZM37.6667 9.33325H35.6667V7.33325C35.6667 7.06804 35.7721 6.81368 35.9596 6.62615C36.1472 6.43861 36.4015 6.33325 36.6667 6.33325C36.932 6.33325 37.1863 6.43861 37.3739 6.62615C37.5614 6.81368 37.6667 7.06804 37.6667 7.33325V9.33325Z",
  fill: "#F7F7F8"
}));

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 12,
  fill: "white",
  transform: "translate(30.6667 4.33325)"
})));

function SvgAttachDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachDisabled);
export default __webpack_public_path__ + "static/media/attach_disabled.50c57d49.svg";
export { ForwardRef as ReactComponent };